/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { RadioGroup, FormControlLabel, Radio, FormLabel, Box } from '@mui/material';

const ComparisonAlignmentFilter = ({ value = false, onChange }) => {
  const handleChange = (event) => {
    onChange?.(event.target.value === 'true');
  };

  return (
    <Box pl={2}>
      <FormLabel>Alignment</FormLabel>

      <RadioGroup
        row
        value={String(value)} // "true" | "false"
        onChange={handleChange}
      >
        <FormControlLabel value="true" control={<Radio />} label="Enable" />
        <FormControlLabel value="false" control={<Radio />} label="Disable" />
      </RadioGroup>
    </Box>
  );
};

export default ComparisonAlignmentFilter;
